'use strict';
import React from 'react/addons';
import {FluxMixin, StoreWatchMixin} from 'fluxxor';
import $ from 'jquery';

import Modal from './Modal';
import ModalOverlay from './ModalOverlay';
import Popover from './Popover';
import Tooltip from './Tooltip';


var cloneWithProps = React.addons.cloneWithProps;


var LayerStack = React.createClass({
  mixins: [
    FluxMixin(React),
    StoreWatchMixin("LayerStore")
  ],

  componentDidUpdate() {
    var numModalLayers = this.state.layers.filter(l => l.type === 'modal').count();

    if (numModalLayers > 0 && !$('html').hasClass('has-open-modal')) {
      $('html, body').addClass('has-open-modal');
    } else if (numModalLayers === 0 && $('html').hasClass('has-open-modal')) {
      $('html, body').removeClass('has-open-modal');
    }
  },

  getStateFromFlux() {
    var flux = this.getFlux();
    return {
      layers: flux.store('LayerStore').state
    };
  },

  render() {
    var layers = [];

    this.state.layers.forEach(function(l) {
      var Component = l.component;
      var style = l.modalStyle;
      if (l.type === 'modal') {
        layers.push(<ModalOverlay />);
        layers.push(
          <Modal
            modalStyle={style}
            popupAd={Component.props.popupAd}>
            {cloneWithProps(Component, {flux: this.getFlux()})}
          </Modal>
        );
      } else if (l.type === 'popover') {
        layers.push(<Popover
          panelAttachment={Component.props.panelAttachment}
          targetAttachment={Component.props.targetAttachment}
          attachTo={Component.props.trigger}>{cloneWithProps(Component, {flux: this.getFlux()})}</Popover>
        );
      } else {
        layers.push(<Tooltip
          panelAttachment={Component.props.panelAttachment}
          targetAttachment={Component.props.targetAttachment}
          attachTo={Component.props.trigger}>{cloneWithProps(Component, {flux: this.getFlux()})}</Tooltip>
        );
      }
    }.bind(this));

    return (
      <div className="ofs-LayerStack">
        {layers}
      </div>
    );
  }
});

export default LayerStack;



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/components/layers/LayerStack.jsx
 **/